import { getLocalStorageEntry, setLocalStorageEntry } from 'src/utils/webStorageUtils';

export type TracingDifficulty = 'easy' | 'medium' | 'hard';

const TRACING_DIFFICULTY_STORAGE_KEY = 'memrise_tracing_difficulty';

export const getStoredTracingDifficulty = (): TracingDifficulty => {
  if (typeof window === 'undefined') return 'easy';

  const stored = getLocalStorageEntry(TRACING_DIFFICULTY_STORAGE_KEY);
  if (stored === 'easy' || stored === 'medium' || stored === 'hard') return stored;
  return 'easy';
};

export const setStoredTracingDifficulty = (difficulty: TracingDifficulty): void => {
  if (typeof window === 'undefined') return;

  setLocalStorageEntry(TRACING_DIFFICULTY_STORAGE_KEY, difficulty);
};
